import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    .tommy-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
    }

    .block-descriptions {
      grid-column: 2 / 8;
      grid-row: 2;
      height: fit-content;
    }

    .carousel-wrapper {
      grid-column: 2 / 8;
      grid-row: 3;
      height: fit-content;
    }

    .carousel-wrapper {
      display: grid;
    }

    .options {
      grid-column: 2 / 8;
      grid-row: 4;
      height: fit-content;
    }

    .rectangle-options-desktop {
      display: none;
    }

    .rectangle-options-mobile {
      display: flex;
      flex-direction: column;
      gap: 10px;
      padding: 10px 0;
    }

    .mobile-buttons-wrapper {
      display: flex;
      justify-content: space-around;
    }

    .mobile-button {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #f0f0f0;
      cursor: pointer;
      width: 45%;
    }

    .mobile-button p {
      padding: calc(10rem / var(--default-rem-px-count)) 0;
    }

    .selected-mobile-button {
      border: 1px solid #979797;
      background-color: unset;
    }

    .mobile-rectangle-carousel {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .mobile-rectangle-carousel .left-arrow {
      margin-left: calc(-10rem / var(--default-rem-px-count));
    }

    .mobile-rectangle-carousel .right-arrow {
      margin-right: calc(-10rem / var(--default-rem-px-count));
    }

    .mobile-rectangle-group-options {
      display: flex;
      flex-direction: row;
      gap: var(--between-column-padding);
      overflow: auto;
      flex: 1;
      scroll-behavior: smooth;
    }

    .mobile-rectangle-group-options::-webkit-scrollbar-thumb {
      background-color: transparent;
    }

    .mobile-rectangle-option-wrapper {
      display: flex;
      flex-direction: column;
      padding: calc(4rem / var(--default-rem-px-count));
    }

    .mobile-rectangle-option-wrapper img {
      margin: auto;
    }

    .carousel-wrapper > .carousel-image > .carousel-image-wrapper {
      min-width: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    /* Layout and type come from image-caption; the anchor is slotted, so it
       stays in this tree and is styled from here. */
    a[slot='control'] {
      cursor: pointer;
    }

    h4 {
      font-size: var(--fs-label-small);
    }

    .download-links {
      display: flex;
      flex-direction: column;
    }

    .description {
      padding-top: calc(40rem / var(--default-rem-px-count));
    }

    .text-sections {
      padding-top: calc(10rem / var(--default-rem-px-count));
      display: flex;
      flex-direction: column;
    }

    .text-section {
      padding-top: calc(24rem / var(--default-rem-px-count));
    }

    .text-section-header {
      font-weight: 500;
    }

    .text-section-paragraph {
      padding-top: calc(14rem / var(--default-rem-px-count));
    }

    /* Old rule had line-height smaller than font-size; caption tokens
       restore a sane ratio. */
    .eyebrow {
      font-size: var(--fs-caption);
      line-height: var(--lh-caption);
      letter-spacing: var(--ls-caption);
      margin-bottom: calc(24rem / var(--default-rem-px-count));
    }

    hr:first-of-type {
      margin-top: 0;
      border: 1px solid black;
    }

    hr:last-of-type {
      margin-bottom: 0;
      border: 1px solid black;
    }

    hr:nth-of-type(2) {
      border: 0.5px solid #cccccc;
    }

    .circle-option-group {
      display: flex;
      flex-direction: row;
      gap: 0 6px;
      justify-content: center;
      padding: calc(7rem / var(--default-rem-px-count)) 0;
    }

    .circle-option-img {
      max-width: calc(20% - calc(10rem / var(--default-rem-px-count)));
      border: 1px solid transparent;
      border-radius: 50%;
      padding: 2px;
      cursor: pointer;
    }

    .circle-option-group img {
      height: calc(40rem / var(--default-rem-px-count));
    }

    .option-label {
      font-size: var(--fs-caption);
      line-height: var(--lh-caption);
      letter-spacing: var(--ls-caption);
      padding-top: calc(10rem / var(--default-rem-px-count));
    }

    .carousel-wrapper .carousel-image {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      background-color: #f0f0f0;
      aspect-ratio: 1.35 / 1;
      overflow: hidden;
    }

    .image-caption-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 0 calc(20rem / var(--default-rem-px-count));
      padding-top: calc(30rem / var(--default-rem-px-count));
    }

    image-caption {
      flex: 1;
    }

    .carousel-controls {
      display: none;
    }

    .top-spacer-mobile {
      padding-top: calc(10rem / var(--default-rem-px-count));
    }

    .carousel-controls-mobile {
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      gap: calc(8rem / var(--default-rem-px-count));
      padding-bottom: calc(10rem / var(--default-rem-px-count));
    }

    .carousel-indicator {
      height: calc(4rem / var(--default-rem-px-count));
      width: calc(4rem / var(--default-rem-px-count));
      border: 1px solid #979797;
      border-radius: 50%;
    }

    .carousel-indicator.selected-indicator {
      background-color: #d8d8d8;
    }

    .carousel-controls span {
      display: flex;
    }

    .carousel-controls span img {
      padding: calc(2rem / var(--default-rem-px-count));
      cursor: pointer;
    }

    .carousel-arrows {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .carousel-arrows {
      cursor: pointer;
      width: calc(30rem / var(--default-rem-px-count));
      height: calc(30rem / var(--default-rem-px-count));
      display: flex;
      align-items: center;
      justify-content: center;
      margin: calc(5rem / var(--default-rem-px-count));
    }

    .carousel-arrows:hover {
      border-radius: 50%;
      background-color: rgba(255, 255, 255, 0.4);
    }

    .carousel-arrows svg {
      width: calc(9rem / var(--default-rem-px-count));
      height: calc(18rem / var(--default-rem-px-count));
    }

    .left-arrow {
      transform: rotate(180deg);
    }

    .not-selected-border {
      border: 1px solid transparent;
    }

    .not-selected-border:hover:not(.selected-border) {
      border-color: #cccccc;
    }

    .selected-border {
      border-color: #979797;
    }

    @media (min-width: 600px) {
      .tommy-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      .block-descriptions {
        grid-column: 2 / 14;
        grid-row: 2;
        padding-bottom: calc(40rem / var(--default-rem-px-count));
      }

      .carousel-wrapper {
        grid-column: 2 / 11;
        grid-row: 3;
      }

      .options {
        grid-column: 11 / 14;
        grid-row: 3;
      }

      .circle-option-group img {
        height: unset;
      }

      .rectangle-options-desktop {
        display: inherit;
      }

      .rectangle-options-mobile {
        display: none;
      }

      .rectangle-option-group {
        display: flex;
        flex-direction: column;
      }

      .rectangle-group-options {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
      }

      .rectangle-option-wrapper {
        width: calc(50% - calc(var(--between-column-padding) / 2) - 2px);
        display: flex;
        flex-direction: column;
        padding: calc(6rem / var(--default-rem-px-count));
        cursor: pointer;
      }

      .rectangle-option-wrapper:nth-child(odd) {
        margin-left: calc(-6rem / var(--default-rem-px-count));
      }

      .rectangle-option-wrapper:nth-child(even) {
        margin-right: calc(-6rem / var(--default-rem-px-count));
      }

      .rectangle-option-wrapper img {
        margin: auto 0;
      }

      .carousel-arrows {
        width: calc(40rem / var(--default-rem-px-count));
        height: calc(40rem / var(--default-rem-px-count));
        aspect-ratio: 1;
      }

      .carousel-wrapper .carousel-image {
        aspect-ratio: 1.2 / 1;
      }

      .carousel-wrapper > .carousel-image > .carousel-image-wrapper {
        justify-content: center;
      }

      .carousel-controls {
        display: flex;
        justify-content: center;
        gap: 0 calc(10rem / var(--default-rem-px-count));
        align-items: center;
        padding-left: calc(5rem / var(--default-rem-px-count));
      }

      .top-spacer-mobile {
        display: none;
      }

      .carousel-controls-mobile {
        display: none;
      }
    }

    @media (min-width: 1024px) {
      .tommy-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      .block-descriptions {
        grid-column: 2 / 5;
        grid-row: 2;
        padding-bottom: 0;
      }

      .carousel-wrapper {
        grid-column: 5 / 12;
        grid-row: 2;
      }

      .options {
        grid-column: 12 / 14;
        grid-row: 2;
      }

      .rectangle-option-wrapper {
        padding: calc(8rem / var(--default-rem-px-count));
      }

      .rectangle-option-wrapper:nth-child(odd) {
        margin-left: calc(-8rem / var(--default-rem-px-count));
      }

      .rectangle-option-wrapper:nth-child(even) {
        margin-right: calc(-8rem / var(--default-rem-px-count));
      }
    }
  `,
];
